var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{staticClass:"ce-productDetails-formulationsList-row"},[_c('td',[(_vm.color)?_c('ColorSpaceBadge',{attrs:{"color":_vm.color}}):_vm._e(),_vm._v("\n    "+_vm._s(_vm.row.shade.title)+"\n  ")],1),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":_vm.row.link}},[_vm._v("\n      "+_vm._s(_vm.row.title)+"\n    ")])])])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }